<template lang="html">
  <em class="">
    <span class="row">
      <span class="col">
        <span v-if="loading" class="loading text-center"><i class="far fa-pulse fa-spinner"></i></span>
        <span v-if="member">{{ memberStatusPretty }}</span>
        <span v-if="accountStatusPretty">{{ accountStatusPretty }}</span>
      </span> <!-- /.col -->
      <span v-if="isPracticeUser && hasOdConnection" class="col">
        <span v-if="loadingPatNum" class="loading text-center"><i class="far fa-pulse fa-spinner"></i></span>
        <span v-if="patNum">{{ patNum }}</span>
      </span> <!-- /.col -->
    </span> <!-- /.row -->
    
  </em>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: ['uid','userType', 'guarantorAccountId'],
  data () {
    return {
      loading: true,
      member: null,
      accountStatus: null,
      loadingPatNum: false,
      patNum: null,
    }
  },
  computed: {
    ...mapGetters(['user_props','user','isPracticeUser','hasOdConnection']),
    accountStatusPretty () {
      if(this.accountStatus && this.accountStatus == "pastDue") {
        return "past due";
      }
      return this.accountStatus;
    },
    memberStatusPretty () {
      if(this.member.subscription_status && this.member.subscription_status == "pastDue") {
        return "past due";
      }
      return this.member.subscription_status;
    },
  },
  mounted() {
    if(this.uid && this.userType && this.guarantorAccountId) {
      // if it's a guarantor, load all their members
      if(this.userType == 'guarantor') {
        Vue.db.ref(`guarantor_accounts/${this.guarantorAccountId}/private/account_status`)
          .once('value')
          .then(snapshot => {
            if(snapshot.val()) {
              this.accountStatus = snapshot.val();
              this.loading = false;
            } else {
              this.accountStatus = "awaiting payment";
              this.loading = false;
              // console.log("error loading guarantor's account status");
            }
          })
          .catch(err => console.log(err));
      }
      // if it's a member, just load the 1 member from guarantor account
      else if(this.userType == 'member') {
        Vue.db.ref(`guarantor_accounts/${this.guarantorAccountId}/private/members/${this.uid}`)
          .once('value')
          .then(snapshot => {
            if(snapshot.val()) {
              this.member = snapshot.val();
              this.loading = false;
            } else {
              // console.log("error loading member's status");
            }
          })
          .catch(err => console.log(err));
        // load member from Firestore to get PatNum
        if(this.isPracticeUser && this.hasOdConnection && this.user && this.user.uid && this.user_props && this.user_props.owned_account_id) {
          this.loadingPatNum = true;
          const memDocPath = `owners/${this.user.uid}/accounts/${this.user_props.owned_account_id}/members/${this.uid}`;
          // console.log({locDocPath});
          // load from firestore
          Vue.firestore
            .doc(memDocPath)
            .get()
            .then(docSnapshot => {
              this.loadingPatNum = false;
              if(docSnapshot && docSnapshot.exists && docSnapshot.data() && docSnapshot.data().pat_num) {
                this.patNum = docSnapshot.data().pat_num;
              } else {
                this.patNum = "none";
              }
              return true;
            })
            .catch(err => console.log(err));
        }
      }
    } else {
      // console.error("no guarantor data to load")
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";
</style>
